// Figures for the Case detail "Student snapshot", derived from the student's exam results.

export interface ScoredResult { created: string; subject: string | null; score_percentage: number | null }

const WEEK = 7 * 86_400_000;
const mean = (xs: number[]) => xs.reduce((a, b) => a + b, 0) / xs.length;

/**
 * Change in the average score over the last four weeks, in points: the mean of all scored results
 * minus the mean of those taken before four weeks ago. Null when either side has no results.
 */
export function averageDelta4w(results: ScoredResult[], now: number = Date.now()): number | null {
  const scored = results.filter((r) => r.score_percentage != null);
  const older = scored.filter((r) => new Date(r.created).getTime() < now - 4 * WEEK);
  if (scored.length === 0 || older.length === 0) return null;
  const d = mean(scored.map((r) => r.score_percentage as number)) - mean(older.map((r) => r.score_percentage as number));
  return Math.round(d * 10) / 10;
}

/** Mean score per subject, weakest first. */
export function subjectAverages(results: ScoredResult[]): { subject: string; pct: number }[] {
  const by = new Map<string, number[]>();
  for (const r of results) {
    if (!r.subject || r.score_percentage == null) continue;
    by.set(r.subject, [...(by.get(r.subject) ?? []), r.score_percentage]);
  }
  return Array.from(by, ([subject, xs]) => ({ subject, pct: Math.round(mean(xs)) }))
    .sort((a, b) => a.pct - b.pct || a.subject.localeCompare(b.subject));
}

/** "−9.2 in 4 wks" / "+3.0 in 4 wks" (a real minus sign). */
export function deltaLabel(d: number): string {
  return `${d < 0 ? '−' : '+'}${Math.abs(d).toFixed(1)} in 4 wks`;
}
